module.exports = __webpack_public_path__ + "img/a.64d188c6.jpg";